window.addEventListener("load", function () {
    document.body.setAttribute("data-status", "loaded");
});


// ==============================================================
// HEADER CHANGE
// ==============================================================
const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);
appHeight();


// ==============================================================
// HEADER CHANGE
// ==============================================================
const header = document.querySelector('.header');
const menuBurger = document.querySelector('.menu-burger');

menuBurger.addEventListener('click', function () {
    this.closest('.header').classList.toggle('menu-active');
});

// SCROLL
window.addEventListener('scroll', handleScroll);
window.addEventListener('load', handleScroll);

function handleScroll() {
    const scrollTop = window.scrollY;
    if (scrollTop >= 24) {
        header.classList.add('header__small');
    } else {
        header.classList.remove('header__small');
    }
}
// DROPDOWN ELEMENTS
// ============================================================
// Перевіряємо, чи є на сторінці dropdown-menu
if (document.querySelector('.dropdown-menu')) {
    // Отримуємо всі елементи dropdown-menu
    const dropdownMenus = document.querySelectorAll('.dropdown-menu');

    // Функція для закриття всіх меню
    const closeAllDropdowns = () => {
        dropdownMenus.forEach(menu => menu.classList.remove('open'));
    };

    // Обробник для кліку на кнопку dropdown-menu__btn
    dropdownMenus.forEach(menu => {
        const btn = menu.querySelector('.dropdown-menu__btn');
        const box = menu.querySelector('.dropdown-menu__box');

        btn.addEventListener('click', (event) => {
            // Якщо поточне меню відкрите, закриваємо його
            if (menu.classList.contains('open')) {
                menu.classList.remove('open');
            } else {
                // Закриваємо всі інші меню
                closeAllDropdowns();

                // Відкриваємо поточне меню
                menu.classList.add('open');
            }

            // Зупиняємо поширення події, щоб запобігти спрацюванню document click
            event.stopPropagation();
        });
    });

    // Закриваємо меню при кліку поза зоною dropdown-menu__box
    document.addEventListener('click', (event) => {
        dropdownMenus.forEach(menu => {
            const box = menu.querySelector('.dropdown-menu__box');
            if (!menu.contains(event.target)) {
                menu.classList.remove('open');
            }
        });
    });

    // Закриваємо меню при зміні ширини вікна
    window.addEventListener('resize', () => {
        closeAllDropdowns();
    });
}



//===============================================================
// Актуальний рік в футері
//===============================================================

var d = new Date();
var y = d.getFullYear();
$('.footer .copyr-year').html(y);


//===============================================================
// Меню в футері
//===============================================================

const footerMenu = document.querySelector('.footer__copyright__col-menu');

document.addEventListener('click', (event) => {
    // Перевіряємо чи натиснули ми на .footer__copyright__col-menu або на його дочірній елемент
    const clickedInsideFooterMenu = footerMenu.contains(event.target);
    const clickedLink = event.target.tagName === 'A';

    if (clickedInsideFooterMenu && !clickedLink) {
        footerMenu.classList.toggle('active');
    } else if (!clickedInsideFooterMenu && footerMenu.classList.contains('active')) {
        footerMenu.classList.remove('active');
    }
});







